import { getFeatureFlag } from './feature-flags-storage';

export const isImportExportEnabled = () => getFeatureFlag('importExport');
